import axios from "axios"

export default {
    namespaced: true,
    state: {
      isOpen: false,
      chat: [],
      isLoadingResponse: false,
      sidebarOfViewIsActive: false,
      viewHasSidenav: false,
      isMinimize: false,
      canBeMaximized: true,
      isHelpViewOpen: false
    },
    getters: {
      getChat(state) {
        return state.chat
      },
      getLoadingStatus(state) {
        return state.isLoadingResponse
      },
      getIsSidebarActive(state) {
        return state.sidebarOfViewIsActive
      },
      getViewHasSidenav(state) {
        return state.viewHasSidenav
      },
    },
    mutations: {
      setViewHasSidenav(state, status) {
        state.viewHasSidenav = status
      },
      setViewSidebarActive(state, status) {
        state.sidebarOfViewIsActive = status
      },
      reloadChat(state) {
        state.chat = []
      },
      addMessage(state, message) {
        state.chat.push(message)
      },
      toggleChatBot(state) {
        state.isOpen = !state.isOpen
      },
      toggleChatbotHelp(state) {
        state.isHelpViewOpen = !state.isHelpViewOpen
      },
      closeChatBot(state) {
        state.isOpen = false
      },
      openChatBot(state) {
        state.isOpen = true
      },
      closeChatbotHelp(state) {
        state.isHelpViewOpen = false
      },
      openChatbotHelp(state) {
        state.isHelpViewOpen = true
      },
      updateLoadinStatus(state, status) {
        state.isLoadingResponse = status
      },
      updateMinimize(state, status) {
        state.isMinimize = status
      },
      updateCanBeMaximized(state, status) {
        state.canBeMaximized = status
      },
      updateMessagesToAlreadyShown(state) {
        state.chat.forEach(message => {
          if(message.from === 'bot') message.alreadyShown = true
        });
      }
    },
    actions: {
      closeSession() {
        axios.post(`${window.__env.VUE_APP_MS_IA_BOT_URL}/omniview_assistant/delete_session`, {}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        })
      }
    },
  }
  